(function () {
  'use strict';

  var MAX_TOTAL = 3;
  var MIN_TOTAL = 2;
  var MAX_EXTRA = MAX_TOTAL - 1;
  var GALLERY_COLLECTIONS = ['ver-todas-las-playeras', 'ver-todos-los-hoodies'];
  var COMPARE_PATH = '/pages/comparar';

  var FILTERS = [
    { id: 'all', label: 'Todos' },
    { id: 'playera', label: 'Playeras', test: function (p) { return p.category === 'playera'; } },
    { id: 'hoodie', label: 'Hoodies', test: function (p) { return p.category === 'hoodie'; } },
    { id: 'boxy', label: 'Boxy', test: function (p) { return p.corte === 'Boxy'; } },
    { id: 'oversize', label: 'Oversize', test: function (p) { return p.corte === 'Oversize'; } },
    { id: 'jersey', label: 'Jersey', test: function (p) { return p.material === 'Jersey'; } },
    { id: 'french-terry', label: 'French Terry', test: function (p) { return p.material === 'French Terry'; } },
    { id: 'felpa', label: 'Felpa', test: function (p) { return p.material === 'Felpa'; } },
  ];

  window.FinhiloCompare = { MAX_TOTAL: MAX_TOTAL, MIN_TOTAL: MIN_TOTAL };

  function handleFromUrl(url) {
    if (!url) return null;
    var match = url.split('?')[0].match(/\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function escapeHtml(str) {
    if (str === undefined || str === null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function buildCompareLink(handle) {
    var link = document.createElement('a');
    link.className = 'compare-toggle';
    link.href = '/pages/comparar?base=' + encodeURIComponent(handle);
    link.innerHTML = '<span class="compare-toggle__button"><span class="compare-toggle__label">Comparar</span></span>';
    return link;
  }

  function injectCardLinks(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var cards = scope.querySelectorAll('.card-wrapper.product-card-wrapper:not([data-compare-ready])');
    cards.forEach(function (card) {
      var linkEl = card.querySelector('a[href*="/products/"]');
      var handle = linkEl ? handleFromUrl(linkEl.getAttribute('href')) : null;
      if (!handle) return;
      card.setAttribute('data-compare-ready', 'true');
      var toggle = buildCompareLink(handle);
      toggle.classList.add('compare-toggle--card');
      card.appendChild(toggle);
    });
  }

  function injectProductLink() {
    var info = document.querySelector('product-info[data-url]:not([data-compare-ready])');
    if (!info) return;
    var handle = handleFromUrl(info.getAttribute('data-url'));
    if (!handle) return;
    var container = info.querySelector('.product__info-container');
    if (!container) return;
    info.setAttribute('data-compare-ready', 'true');
    var toggle = buildCompareLink(handle);
    toggle.classList.add('compare-toggle--product');
    container.insertBefore(toggle, container.firstChild);
  }

  function initInjection() {
    injectCardLinks(document);
    injectProductLink();
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            injectCardLinks(node);
          });
        });
        injectProductLink();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  var SCALE_LABELS = {
    ligereza: ['Ligera', 'Pesada'],
    estructura: ['Fluida', 'Estructurada'],
    grosor: ['Delgado', 'Grueso'],
    suavidad: ['Rígida', 'Suave'],
    abrigo: ['Fresca', 'Abrigadora'],
  };

  function fetchSectionJson(url, selector) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.querySelector(selector);
        if (!script) return null;
        try { return JSON.parse(script.textContent); } catch (e) { return null; }
      })
      .catch(function () { return null; });
  }

  function fetchProductData(handle, sectionId) {
    return fetchSectionJson('/products/' + handle + '?section_id=' + sectionId, '[data-compare-json]');
  }

  function fetchCollectionGallery(collectionHandle, sectionId) {
    return fetchSectionJson('/collections/' + collectionHandle + '?section_id=' + sectionId, '[data-compare-gallery-json]').then(function (data) {
      return data || [];
    });
  }

  function fetchAllGalleryProducts(sectionId) {
    return Promise.all(GALLERY_COLLECTIONS.map(function (handle) { return fetchCollectionGallery(handle, sectionId); })).then(function (lists) {
      var seen = {};
      var merged = [];
      lists.forEach(function (list) {
        list.forEach(function (p) {
          if (seen[p.handle]) return;
          seen[p.handle] = true;
          merged.push(p);
        });
      });
      return merged;
    });
  }

  function scaleMarkup(leftLabel, rightLabel, value) {
    var v = Math.min(5, Math.max(1, parseInt(value, 10) || 3));
    var dots = '';
    for (var i = 1; i <= 5; i++) {
      dots += '<span class="compare-scale__dot' + (i <= v ? ' is-filled' : '') + '"></span>';
    }
    return (
      '<div class="compare-scale">' +
      '<span class="compare-scale__label compare-scale__label--left">' + escapeHtml(leftLabel) + '</span>' +
      '<span class="compare-scale__dots">' + dots + '</span>' +
      '<span class="compare-scale__label compare-scale__label--right">' + escapeHtml(rightLabel) + '</span>' +
      '</div>'
    );
  }

  function rowHasAnyValue(products, key) {
    return products.some(function (p) {
      var v = p[key];
      return v !== undefined && v !== null && String(v).length > 0;
    });
  }

  function tableRow(products, key, options) {
    options = options || {};
    if (!rowHasAnyValue(products, key)) return '';
    var html = '<tr class="compare-table__row' + (options.recommendation ? ' compare-table__row--recommendation' : '') + '">';
    html += '<th scope="row" class="compare-table__row-label">' + escapeHtml(options.label) + '</th>';
    products.forEach(function (p) {
      var value = p[key];
      html += '<td class="compare-table__cell">';
      if (options.scale) {
        var labels = SCALE_LABELS[key] || ['', ''];
        html += value ? scaleMarkup(labels[0], labels[1], value) : '—';
      } else if (options.recommendation) {
        html += value ? '<span class="compare-recommendation">' + escapeHtml(value) + '</span>' : '—';
      } else {
        html += escapeHtml(value || '—');
      }
      html += '</td>';
    });
    html += '</tr>';
    return html;
  }

  function sectionTitleRow(title, colspan) {
    return '<tr class="compare-table__section-row"><th class="compare-table__section-title" colspan="' + colspan + '">' + escapeHtml(title) + '</th></tr>';
  }

  function renderTable(products) {
    var colspan = products.length + 1;
    var html = '<div class="compare-table-wrapper"><table class="compare-table"><thead><tr class="compare-table__row compare-table__row--header"><th scope="col" class="compare-table__row-label"></th>';
    products.forEach(function (p) {
      html +=
        '<th scope="col" class="compare-table__header-cell">' +
        (p.image ? '<img class="compare-table__image" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="200" height="250">' : '') +
        '<span class="compare-table__title">' + escapeHtml(p.title) + '</span>' +
        (p.subtitle ? '<span class="compare-table__subtitle">' + escapeHtml(p.subtitle) + '</span>' : '') +
        '<span class="compare-table__price">' + escapeHtml(p.price) + '</span>' +
        '<a class="compare-table__link link" href="' + p.url + '">Ver producto</a>' +
        '</th>';
    });
    html += '</tr></thead><tbody>';
    html += sectionTitleRow('¿Para qué funciona mejor?', colspan);
    html += tableRow(products, 'usoIdeal', { label: 'Uso ideal' });
    html += tableRow(products, 'tipoColeccion', { label: 'Tipo de colección' });
    html += tableRow(products, 'momento', { label: 'Momento recomendado' });
    html += tableRow(products, 'temporada', { label: 'Temporada' });
    html += sectionTitleRow('Cómo se siente la prenda', colspan);
    html += tableRow(products, 'sensacion', { label: 'Sensación al vestir' });
    html += tableRow(products, 'ligereza', { label: 'Ligereza', scale: true });
    html += tableRow(products, 'estructura', { label: 'Estructura', scale: true });
    html += tableRow(products, 'grosor', { label: 'Grosor', scale: true });
    html += tableRow(products, 'suavidad', { label: 'Suavidad', scale: true });
    html += tableRow(products, 'abrigo', { label: 'Abrigo', scale: true });
    html += sectionTitleRow('Características de la prenda', colspan);
    html += tableRow(products, 'gramaje', { label: 'Gramaje' });
    html += tableRow(products, 'material', { label: 'Material' });
    html += tableRow(products, 'corte', { label: 'Corte' });
    html += sectionTitleRow('Elígela según lo que quieras crear', colspan);
    html += tableRow(products, 'recomendacion', { label: '', recommendation: true });
    html += '</tbody></table></div>';
    return html;
  }

  /* ---- Flujo guiado (pasos 1 y 2): piezas compartidas ----
     Reutilizan la misma galeria (colecciones de playeras + hoodies), los mismos filtros y el mismo
     markup de .compare-gallery__item que ya usaba la seleccion desde una card/PDP. */
  function stepsMarkup(active, baseTitle, secondTitle) {
    function step(n, label, value) {
      var state = n === active ? ' is-active' : n < active ? ' is-done' : '';
      return (
        '<li class="compare-steps__item' + state + '"' + (n === active ? ' aria-current="step"' : '') + '>' +
        '<span class="compare-steps__num">' + n + '</span>' +
        '<span class="compare-steps__text"><span class="compare-steps__label">' + escapeHtml(label) + '</span>' +
        (value ? '<span class="compare-steps__value">' + escapeHtml(value) + '</span>' : '') +
        '</span></li>'
      );
    }
    return (
      '<ol class="compare-steps" aria-label="Pasos para comparar">' +
      step(1, 'Prenda base', baseTitle) +
      step(2, 'Prenda a comparar', secondTitle) +
      '</ol>'
    );
  }

  function galleryItemMarkup(p) {
    return (
      '<button type="button" class="compare-gallery__item" data-gallery-handle="' + escapeHtml(p.handle) + '" aria-pressed="false">' +
      (p.image ? '<span class="compare-gallery__image-wrap"><img class="compare-gallery__image" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="200" height="250"></span>' : '') +
      '<span class="compare-gallery__check" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10.5L8 14.5L16 5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '<span class="compare-gallery__title">' + escapeHtml(p.title) + '</span>' +
      '</button>'
    );
  }

  function filterBarMarkup(activeId) {
    var html = '<div class="compare-filter-bar" role="group" aria-label="Filtrar productos">';
    FILTERS.forEach(function (f) {
      html += '<button type="button" class="compare-filter-bar__chip' + (f.id === activeId ? ' is-active' : '') + '" data-filter-id="' + f.id + '">' + escapeHtml(f.label) + '</button>';
    });
    html += '</div>';
    return html;
  }

  /* Monta filtros + galeria dentro de scope. onPick(handle) se llama al elegir una prenda.
     isSelected(handle) marca la prenda elegida actualmente (si la hay). */
  function mountGallery(app, scope, gallery, onPick, isSelected) {
    var galleryEl = scope.querySelector('[data-compare-gallery]');
    var galleryEmptyEl = scope.querySelector('[data-gallery-empty]');
    var filterButtons = Array.prototype.slice.call(scope.querySelectorAll('.compare-filter-bar__chip'));

    function render() {
      var filter = FILTERS.filter(function (f) { return f.id === app.activeFilter; })[0];
      var visible = !filter || !filter.test ? gallery : gallery.filter(filter.test);
      if (!visible.length) {
        galleryEl.innerHTML = '';
        galleryEmptyEl.hidden = false;
        return;
      }
      galleryEmptyEl.hidden = true;
      galleryEl.innerHTML = visible.map(galleryItemMarkup).join('');
      Array.prototype.slice.call(galleryEl.querySelectorAll('.compare-gallery__item')).forEach(function (item) {
        var h = item.getAttribute('data-gallery-handle');
        var sel = !!(isSelected && isSelected(h));
        item.classList.toggle('is-selected', sel);
        item.setAttribute('aria-pressed', sel ? 'true' : 'false');
        item.addEventListener('click', function () { onPick(h); });
      });
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        app.activeFilter = btn.getAttribute('data-filter-id');
        filterButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        render();
      });
    });

    render();
  }

  function galleryShellMarkup(activeFilter) {
    return (
      filterBarMarkup(activeFilter) +
      '<div class="compare-selection__gallery">' +
      '<div class="compare-gallery" data-compare-gallery></div>' +
      '<p class="compare-page__empty-inline" data-gallery-empty hidden>No encontramos productos para este filtro.</p>' +
      '</div>'
    );
  }

  function CompareApp(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id') || 'main-compare-data';
    this.gallerySectionId = root.getAttribute('data-gallery-section-id') || 'main-compare-gallery-data';
    this.titleEl = document.querySelector('[data-compare-title]');
    this.subEl = document.querySelector('[data-compare-subheading]');
    this.defaultTitle = this.titleEl ? this.titleEl.textContent : '';
    this.defaultSub = this.subEl ? this.subEl.textContent : '';
    this.base = null;
    this.extra = [];
    this.activeFilter = 'all';
    this.galleryCache = null;
    window.addEventListener('popstate', this.route.bind(this));
    this.route();
  }

  CompareApp.prototype.setHeader = function (title, sub) {
    if (this.titleEl) this.titleEl.textContent = title;
    if (this.subEl) {
      this.subEl.textContent = sub || '';
      this.subEl.style.display = sub ? '' : 'none';
    }
  };

  CompareApp.prototype.go = function (query) {
    window.history.pushState({}, '', COMPARE_PATH + (query ? '?' + query : ''));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  CompareApp.prototype.loadGallery = function () {
    var self = this;
    if (this.galleryCache) return Promise.resolve(this.galleryCache);
    return fetchAllGalleryProducts(this.gallerySectionId).then(function (gallery) {
      self.galleryCache = gallery || [];
      return self.galleryCache;
    });
  };

  CompareApp.prototype.route = function () {
    var params = new URLSearchParams(window.location.search);
    var items = params.get('items');
    var base = params.get('base');
    if (items) {
      var handles = items.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, MAX_TOTAL);
      this.base = handles[0] || null;
      this.extra = handles.slice(1);
      this.renderComparison(handles);
    } else if (base) {
      this.base = base;
      this.activeFilter = 'all';
      this.renderSelection();
    } else {
      this.renderEmpty();
    }
  };

  /* Sin productos: paso 1, elegir la prenda base dentro de la propia pagina. */
  CompareApp.prototype.renderEmpty = function () {
    var self = this;
    var previousBase = this.base;
    this.setHeader('¿Qué quieres comparar?', 'Elige la prenda que quieres tomar como referencia.');
    this.renderLoading();

    this.loadGallery().then(function (gallery) {
      if (!gallery.length) {
        self.root.innerHTML = '<div class="compare-page__empty"><p>No pudimos cargar las prendas. Intenta de nuevo en un momento.</p></div>';
        return;
      }
      var html = '<div class="compare-selection compare-selection--base">';
      html += stepsMarkup(1, '', '');
      html += galleryShellMarkup(self.activeFilter);
      html += '</div>';
      self.root.innerHTML = html;

      mountGallery(self, self.root, gallery, function (handle) {
        var keep = self.extra.filter(function (h) { return h !== handle; });
        self.base = handle;
        self.extra = keep.slice(0, 1);
        self.activeFilter = 'all';
        self.go('base=' + encodeURIComponent(handle));
        self.renderSelection();
      }, function (h) { return h === previousBase; });
    });
  };

  CompareApp.prototype.renderLoading = function () {
    this.root.innerHTML =
      '<div class="compare-page__loading"><div class="loading__spinner"><svg class="spinner" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';
  };

  /* Paso 2: la prenda base ya esta elegida (desde el paso 1 o desde una card/PDP con ?base=).
     Al elegir la segunda prenda se muestra automaticamente la comparacion existente. */
  CompareApp.prototype.renderSelection = function () {
    var self = this;
    this.setHeader('Elige la segunda prenda', 'Selecciona otra opción para compararlas lado a lado.');
    this.renderLoading();

    fetchProductData(this.base, this.sectionId).then(function (baseProduct) {
      if (!baseProduct) {
        self.root.innerHTML =
          '<div class="compare-page__empty"><p>No pudimos encontrar ese producto.</p></div>' +
          '<div class="compare-page__restart"><button type="button" class="link compare-page__change" data-compare-restart>Elegir otra prenda base</button></div>';
        var restart = self.root.querySelector('[data-compare-restart]');
        if (restart) restart.addEventListener('click', function () { self.base = null; self.go(''); self.renderEmpty(); });
        return;
      }
      self.loadGallery().then(function (gallery) {
        gallery = (gallery || []).filter(function (p) { return p.handle !== self.base; });
        self.renderSelectionUI(baseProduct, gallery);
      });
    });
  };

  CompareApp.prototype.renderSelectionUI = function (baseProduct, gallery) {
    var self = this;
    var current = this.extra[0] || null;

    var html = '<div class="compare-selection">';
    html += stepsMarkup(2, baseProduct.title, '');
    html += '<div class="compare-selection__base">';
    html += '<span class="compare-selection__base-label">Prenda base</span>';
    html += '<div class="compare-base-card">';
    html += (baseProduct.image ? '<img class="compare-base-card__image" src="' + baseProduct.image + '" alt="' + escapeHtml(baseProduct.title) + '" loading="lazy" width="160" height="200">' : '');
    html += '<span class="compare-base-card__title">' + escapeHtml(baseProduct.title) + '</span>';
    html += '</div>';
    html += '<button type="button" class="link compare-page__change compare-selection__change-base" data-change-base>Cambiar prenda base</button>';
    html += '</div>';
    html += '<p class="compare-selection__hint">Ahora elige con cuál la quieres comparar.</p>';
    html += galleryShellMarkup(this.activeFilter);
    html += '</div>';

    this.root.innerHTML = html;

    var changeBase = this.root.querySelector('[data-change-base]');
    if (changeBase) {
      changeBase.addEventListener('click', function () {
        self.activeFilter = 'all';
        self.go('');
        self.renderEmpty();
      });
    }

    mountGallery(this, this.root, gallery, function (handle) {
      var handles = [self.base, handle];
      self.extra = [handle];
      self.go('items=' + handles.map(encodeURIComponent).join(','));
      self.renderComparison(handles);
    }, function (h) { return h === current; });
  };

  CompareApp.prototype.renderComparison = function (handles) {
    var self = this;
    this.setHeader(this.defaultTitle, this.defaultSub);
    this.renderLoading();

    Promise.all(handles.map(function (h) { return fetchProductData(h, self.sectionId); })).then(function (results) {
      var products = results.filter(Boolean);
      if (products.length < MIN_TOTAL) {
        self.renderEmpty();
        return;
      }
      var others = products.slice(1).map(function (p) { return p.title; }).join(' y ');
      var html = '<div class="compare-summary">';
      html += '<p class="compare-summary__text"><span class="compare-summary__label">Prenda base</span> ' + escapeHtml(products[0].title) +
        ' <span class="compare-summary__sep" aria-hidden="true">·</span> <span class="compare-summary__label">Comparada con</span> ' + escapeHtml(others) + '</p>';
      html += '<div class="compare-page__actions">';
      html += '<button type="button" class="link compare-page__change" data-compare-change-base>Cambiar prenda base</button>';
      html += '<button type="button" class="link compare-page__change" data-compare-change>Cambiar segunda prenda</button>';
      html += '</div></div>';
      html += renderTable(products);
      self.root.innerHTML = html;

      var changeBtn = self.root.querySelector('[data-compare-change]');
      if (changeBtn) {
        changeBtn.addEventListener('click', function () {
          self.activeFilter = 'all';
          self.go('base=' + encodeURIComponent(self.base));
          self.renderSelection();
        });
      }
      var changeBaseBtn = self.root.querySelector('[data-compare-change-base]');
      if (changeBaseBtn) {
        changeBaseBtn.addEventListener('click', function () {
          self.activeFilter = 'all';
          self.go('');
          self.renderEmpty();
        });
      }
    });
  };

  function initComparePage() {
    var root = document.querySelector('[data-compare-page]');
    if (!root) return;
    new CompareApp(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initInjection();
    initComparePage();
  });
})();
